<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="actionStart" v-if="!state.loading"/>
        <div class="content" v-show="!state.loading">
            <div class="rctr v-flex">
                <div class="ctr">
                    <p>Account</p>
                    <select id="monthSelect" v-model="selectedMonth">
                        <option v-for="month in monthsList" :key="month.value" :value="month.value">
                            {{ month.label }}
                        </option>
                    </select>
                </div>
            </div>
            <SpreadSheet
                :header="header"
                :data="spreadsheetData"
                @cell-updated="handleUpdate"
                />
        </div>
        <div v-if="state.loading" style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>
    
</template>
<script>
import icons from '@/assets/js/icons.js';
import { reactive, ref, onMounted, watch, computed} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import SpreadSheet from '@/components/SpreadSheet.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
export default {
    name: 'PaySalary',
    components:{PageHeader, SpreadSheet},
    setup(){
        const store= useStore();
        const system = computed(() => store.state.System.system);
        const route = useRoute();
        const router = useRouter();
        const viewFields=ref([])
        const monthsList=ref([])
        const summary=ref([]);
        const generated=ref(false)
        const spreadsheetData=ref([])
        const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
        loading:true});
        const svgIcons = ref(icons);
        const selectedMonth=ref(null);
        const page=ref({title:"Payroll", btn:"Generate Payroll",
            desc:"An easy way to record salary payment -- Generate Payroll for this month to record salary payment"})
        
        var action_label=[icons.view],
        action=["view"]
        
        const header = ref([
            { id: 'h1', value: 'Staff' },
            { id: 'h2', value: 'Basic' },
            { id: 'h3', value: "This Month's Items" },
            { id: 'h3', value: 'Pay Amount' }
        ])

        function handleUpdate({ cell, rowIndex, columnIndex }) {
            var id=cell.id;
            spreadsheetData.value[rowIndex][columnIndex].updating=true;
            call({
                url:urls.transactions,
                data:{updatemPayItem:id,data:cell.value},
                success:(res)=>{
                    if(res.status){
                        // spreadsheetData.value = updatedData
                        spreadsheetData.value[rowIndex][columnIndex].updating=false;
                    }else{
                        alert(res.msg);
                    }
                }
            })
        }

        watch(
            () => route.fullPath,
            () => {
                getPage();
            }
        );

        watch(selectedMonth, (newVal) => {
            router.push({ name: 'paysalary', query: { month: newVal } });
        });

        // function setTable(msg){
        //     var data={}
        //     tableData.value.loading = false;
        //     tableData.value.rows.length=0
        //     Object.keys(msg).forEach(set => {
        //         data={id:msg[set].id};
        //         var v=[];
        //         Object.keys(msg[set].val).forEach(row => {
        //         v.push(msg[set].val[row])
        //         });
        //         data.val=v;
        //         tableData.value.rows.push(data)
        //     });
        //     tableData.value.total=tableData.value.rows.length
        // }

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Staff" },
                { label: "Basic" },
                { label: "This Month's Items" },
                { label: "This Month's Pay" }
            ],
            options:{
                label:"",
                action_label:action_label,
                action:action,
            },
            total:0
        });

        function getPage(){
            state.loading=true;
            var data={startPaySalary:selectedMonth.value}
            page.value.btn="Generate Payroll";
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        var d=res.msg;
                        spreadsheetData.value.length=0;
                        Object.keys(d.staff).forEach(key => {
                            spreadsheetData.value.push(d.staff[key])
                        });
                        generated.value=false
                        if(d.generated){
                            generated.value=true;
                            page.value.btn="Submit Payroll";
                            page.value.desc="You can adjust the final amount for each staff if they're not receiving full salary this month before submitting";
                        }
                        state.success=true;
                    }else{
                        alert(res.msg);
                    }
                }
            })
        }

        onMounted(() => {
            generateMonths()
            getPage();
        });

        // function setErrors(res){
        //     var errors=[];
        //     Object.keys(res.msg).forEach(key => {
        //         var e=res.msg[key],er="";
        //         Object.keys(e).forEach(k => {
        //         er+=er=="" ? e[k] : ", "+e[k]
        //         })
        //         errors.push(er);
        //     });
        //     state.errors=errors;
        // }

        function generateMonths() {
            const startYear = 2010;
            const now = new Date();
            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];

            let currentYear = now.getFullYear();
            let currentMonth = now.getMonth(); // 0-indexed
            let q=route.query;
            if(q.month){
                selectedMonth.value=q.month
            }else{
                selectedMonth.value=`1-${String(currentMonth + 1).padStart(2, '0')}-${currentYear}`;
            }

            while (currentYear > startYear || (currentYear === startYear && currentMonth >= 0)) {
                const value = `1-${String(currentMonth + 1).padStart(2, '0')}-${currentYear}`;
                const label = `${monthNames[currentMonth]} ${currentYear}`;
                monthsList.value.push({ value, label });

                // Move to previous month
                currentMonth--;
                if (currentMonth < 0) {
                currentMonth = 11;
                currentYear--;
                }
            }
        }

        function actionStart(){
            if(system.value.acct_type==""){
                alert("Office accounting settings not found. Please contact your system administrator to configure accounting settings to continue")
                return;
            }
            state.loading=true;
            var data={generatePayroll:selectedMonth.value}
            if(generated.value){
                data={submitPayroll:selectedMonth.value}
            }
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        var d=res.msg;
                        spreadsheetData.value.length=0;
                        Object.keys(d.staff).forEach(key => {
                            spreadsheetData.value.push(d.staff[key])
                        });
                        if(d.generated){
                            generated.value=true;
                            page.value.btn="Submit Payroll";
                            page.value.desc="You can adjust the final amount for each staff if they're not receiving full salary this month before submitting";
                        }
                        state.success=true;
                    }else{
                        alert(res.msg);
                    }
                }
            })
        }
        

        return{state, icons:svgIcons,tableData,page,
            viewFields,monthsList, selectedMonth,actionStart,
            summary,handleUpdate,header,spreadsheetData}
    }
}
</script>

<style scoped>
    .rctr{gap:5px}
    .rctr .ctr{display:flex; flex-direction: column;}
    .rctr .ctr p{color: var(--black);margin: 0; font-weight: bold; font-size: 13px;}
    .rsumry{padding: 10px 0; color: var(--black); display: inline-block;}
    .rsumry .smry{padding: 10px; background: var(--white-color); margin-bottom: 5px;}
    .rsumry span{display:block;margin-bottom: 5px; padding-left: 10px;}
    .rsumry > div{margin-bottom:10px}
</style>